<template>
  <div
    ref="el"
    class="animation" />
</template>

<script>
import animate from "@/services/animate";

export default {
  name: "Animation",
  props: {
    id: {
      type: String,
      required: true
    }
  },
  mounted() {
    animate(this.$refs.el, this.id);
  }
};
</script>

<style lang="scss">
.animation {
  width: 100%;
  height: 100%;

  /* stylelint-disable-next-line selector-nested-pattern */
  > svg {
    display: block;
  }
}
</style>
